import React, { Component } from "react"
import "./search_form.scss"
import { loadPikadayIfNeeded } from "../../top/index/pikaday_loader"
import moment from 'moment'
import { ucfirst } from '../../search/index/utils'
import { countryPrefectureNames } from '../../common/constants/prefectures'
const PREFECTURES = countryPrefectureNames()

export class SearchForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      ...this.props.query
    }

    this.onChangeValue = this.onChangeValue.bind(this)

    moment.locale(this.props.lang)
  }

  componentDidMount() {
    loadPikadayIfNeeded()
    // pikadayで日付選択時のみ、onchange が発火しないため
    const checkin = document.getElementById('checkin')
    const checkout = document.getElementById('checkout')
    checkin && (checkin.onchange = () => this.setState({checkin: checkin.value}))
    checkout && (checkout.onchange = () => this.setState({checkout: checkout.value}))
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search != this.props.location.search) {
      this.setState(this.props.query)
    }
  }

  addDays(date, days) {
    const daysInSeconds = days * 24 * 60 * 60 * 1000
    return new Date(date.getTime() + daysInSeconds)
  }

  ymd(date) {
    const y = date.getFullYear()
    const m = ('0' + (date.getMonth() + 1)).slice(-2)
    const d = ('0' + date.getDate()).slice(-2)
    return `${y}-${m}-${d}`
  }

  get minCheckin() {
    return new Date()
  }

  get minCheckout() {
    return this.addDays(this.minCheckin, 1)
  }

  get maxCheckin() {
    return this.addDays(this.minCheckin, 365 * 2)
  }

  get maxCheckout() {
    return this.addDays(this.minCheckout, 365 * 2)
  }

  guestsNumberSelector() {
    const MAX_GUESTS = 15

    const options = Array.from(Array(MAX_GUESTS)).map((e, i) => {
      return <option key={i} value={i + 1} >{i + 1}名</option>
    })

    return <select
      aria-label="人数（2歳以上）"
      styleName="adults-select"
      id="adults"
      name="adults"
      data-has-changed="true"
      defaultValue={this.props.query.adults}
      onChange={this.onChangeValue}
    >
      {options}
    </select>
  }

  onChangeValue(e) {
    const { name, value } = e.target
    this.setState({ [name]: value || undefined })
  }

  render() {
    return (
      <section styleName="search-form-container">
        <h2 styleName="search-form-heading">{this.props.heading}</h2>
        <div styleName="search-form-wrapper">
          <form
            action={this.props.action}
            styleName="search-form"
            className="js-search-form"
            method="get"
            name="searchForm"
            data-bound="true"
            onSubmit={(e) => {
              e.preventDefault()
              this.props.onSubmitForm(this.state)
            }}
          >
            <div styleName="search-form-input-group">
              <div styleName="select-prefecture">
                <label styleName="select-prefecture-label" htmlFor="prefecture">
                都道府県
                </label>
                <div styleName="select-prefecture-wrap">
                  <select
                    aria-label="都道府県"
                    styleName="adults-select"
                    id="prefecture"
                    name="prefecture"
                    data-has-changed="true"
                    value={this.state.prefecture || this.props.query.prefecture}
                    onChange={this.onChangeValue}
                  >
                    {
                      this.props.prefectures.map((prefecture, index) => {
                        return <option key={index} value={prefecture.key}>
                          { PREFECTURES[prefecture.key] }
                        </option>
                      })
                    }
                  </select>
                </div>
              </div>

              <div styleName="date-range-container">
                <div
                  styleName="date-range-input-container"
                  className="js-date-range-input-container"
                  data-is-pikaday="true"
                >
                  <label styleName="date-range-label" htmlFor="checkin">
                  チェックイン
                  </label>
                  <input
                    aria-label="年/月/日"
                    styleName="date-range-input" className="js-date-range-input"
                    id="checkin"
                    name="checkin"
                    min={this.ymd(this.minCheckin)}
                    max={this.ymd(this.maxCheckin)}
                    defaultValue={this.props.query.checkin}
                    placeholder="年/月/日"
                    type="date"
                    autoComplete="off"
                    onChange={this.onChangeValue}
                  />
                </div>
                <div
                  styleName="date-range-input-container"
                  className="js-date-range-input-container"
                  data-is-pikaday="true"
                >
                  <label styleName="date-range-label" htmlFor="checkout">
                  チェックアウト
                  </label>
                  <input
                    aria-label="年/月/日"
                    styleName="date-range-input" className="js-date-range-input"
                    id="checkout"
                    name="checkout"
                    min={this.ymd(this.minCheckout)}
                    max={this.ymd(this.maxCheckout)}
                    defaultValue={this.props.query.checkout}
                    placeholder="年/月/日"
                    type="date"
                    autoComplete="off"
                    onChange={this.onChangeValue}
                  />
                </div>
              </div>
              <div styleName="select-guests">
                <label styleName="select-guests-label" htmlFor="adults">
                人数（2歳以上）
                </label>
                <div styleName="select-guests-wrap">
                  {this.guestsNumberSelector()}
                </div>
              </div>
              <div styleName="submit-btn">
                <button
                  styleName="btn-primary"
                  className="extended"
                  type="submit"
                >
                  <span className="vs-icon-search"></span>
                  <span styleName="btn-label">検索</span>
                </button>
              </div>
              <input
                className="js-hidden-destination-input"
                type="hidden"
                name="destination"
              />
              <input name="sort" type="hidden" value="distance_asc" />
            </div>
          </form>
        </div>

      </section>
    )
  }
}

export default SearchForm
